export interface SubDataItem {
  title: string;
  link: string | null;
}

export interface ExampleItem {
  title: string;
  subData: SubDataItem[];
}

export const ExampleDatas: ExampleItem[] = [{
  title: 'อัตรา 5%',
  subData: [{
    title: 'ค่าเช่า',
    link: 'https://www.itax.in.th/pedia/เงินได้ประเภทที่-5'
  }, {
    title: 'รางวัลจากการชิงโชคหรือการประกวดแข่งขัน',
    link: null
  }, {
    title: 'ค่าตัวนักแสดงสาธารณะ',
    link: 'https://www.itax.in.th/pedia/นักแสดงสาธารณะ'
  }]
}, {
  title: 'อัตรา 3%',
  subData: [{
    title: 'ค่าบริการ',
    link: null
  }, {
    title: 'ค่าวิชาชีพอิสระ',
    link: 'https://www.itax.in.th/pedia/เงินได้ประเภทที่-6'
  }, {
    title: 'ค่าลิขสิทธิ์',
    link: 'https://www.itax.in.th/pedia/เงินได้ประเภทที่-3'
  }]
}, {
  title: 'อัตรา 2%',
  subData: [{
    title: 'ค่าโฆษณา',
    link: null
  }]
}, {
  title: 'อัตรา 1%',
  subData: [{
    title: 'ค่าขนส่ง',
    link: null
  }, 
  // {
  //   title: 'ค่าบริการที่หักภาษีผ่านระบบ "e-Withholding Tax"',
  //   link: 'https://www.itax.in.th/pedia/e-withholding-tax-ภาษีหัก-ณ-ที่จ่าย-อิเล็กทรอนิกส์/'
  // }
  ]
}];

export interface Item {
  id: number;
  label: string;
}

export const DropdownDatas: Item[] = [{
  id: 1,
  label: 'ก่อน VAT'
}, {
  id: 2,
  label: 'รวม VAT'
}, {
  id: 3,
  label: 'หลังหักภาษี ณ ที่จ่าย'
}];

export const DefaultDropdown: Item = {
  id: 1,
  label: 'ก่อน VAT'
};

export enum CalculateType {
  beforeVat = 1,
  withVat,
  withHoldingTax
}

export const defaultValue = '0';
export const defaultTax = 3;
export const defaultVat = 7;
export const hundredPercent = 100.00;

export const BankList = [{
  value: 'promptpay',
  name: 'PromptPay',
  inputLen: 10,
},{  
  value: 'kbank',
  name: 'ธ.กสิกรไทย',
  inputLen: 10,
},{  
  value: 'scb',
  name: 'ธ.ไทยพาณิชย์',
  inputLen: 10,
},{  
  value: 'bbl',
  name: 'ธ.กรุงเทพ',
  inputLen: 10,
},{  
  value: 'bay',
  name: 'ธ.กรุงศรีอยุธยา',
  inputLen: 10,
},{  
  value: 'ktb',
  name: 'ธ.กรุงไทย',
  inputLen: 10,
},{  
  value: 'cimb',
  name: 'ธ.ซีไอเอ็มบี',
  inputLen: 10,
},{  
  value: 'baac',
  name: 'ธ.ก.ส.',
  inputLen: 12,
},{  
  value: 'ttb',
  name: 'ธ.ทหารไทยธนชาต',
  inputLen: 10,
},{  
  value: 'gsb',
  name: 'ธ.ออมสิน',
  inputLen: 12,
},{  
  value: 'uob',
  name: 'ธ.ยูโอบี',
  inputLen: 10,
},{  
  value: 'kkp',
  name: 'ธ.เกียรตินาคินภัทร',
  inputLen: 14,
}]

export interface VatLog {
  visitor_id: string
  user_type: string
  input_type: string
  value: number
  vat: number
  tax: number
  consent?: boolean | null
  bank?: string | null
  account_no?: string | null
  account_name?: string | null
}